import { Injectable } from '@angular/core';
import { Http, URLSearchParams, Headers } from '@angular/http';
import 'rxjs/Rx';
import { URL_SERVICIOS } from '../../conf/url.servicios';
import { Router } from '@angular/router';
import { ConsultaService } from '../services/consulta.service';

@Injectable()
export class CategoriasService {

  constructor(private router: Router, public http: Http, private consultaService: ConsultaService) { }
  categorias: any = [];
  idCategoria: any;
    imagenes: any = [];


  eliminarCategoria(paramId: any): any {


    console.log("::: Blog eliminaBlog service ");
    var obj: any = {};
    if (this.consultaService.esNuevaSession) {
      obj.N_ID = paramId
      obj.idUsuario = localStorage.getItem("paramId");
      obj.token = localStorage.getItem("paramToken");
      console.log(obj);
      //console.log(paramBlog);
      let promesa = new Promise((resolve, reject) => {
        let data = new URLSearchParams();
        let url = URL_SERVICIOS + '/categorias/eliminarCategoria';
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, obj, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            //console.log(data);
            resolve(true);
          })
      });
      return promesa;
    }
  }

  guardarCategoria(paramCategoria: any): any {

    console.log("Producto a guardar");
    console.log(paramCategoria);
    if (this.consultaService.esNuevaSession) {
      paramCategoria.idUsuario = localStorage.getItem("paramId");
      paramCategoria.token = localStorage.getItem("paramToken");
      let promesa = new Promise((resolve, reject) => {
        let data = new URLSearchParams();
        let url = URL_SERVICIOS + '/categorias/guardaCategoria';
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, paramCategoria, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            this.idCategoria = data.idFinal;
            resolve(true);
          })
      });
      return promesa;
    }
  }


  guardaRelacionImgMC(paramRel: any): any {
    if (this.consultaService.esNuevaSession) {
      paramRel.idUsuario = localStorage.getItem("paramId");
      paramRel.token = localStorage.getItem("paramToken");
      let promesa = new Promise((resolve, reject) => {
        let data = new URLSearchParams();
        let url = URL_SERVICIOS + '/categorias/guardaRelacionMCImg';
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, paramRel, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            resolve(true);
          })
      });
      return promesa;
    }
  }

  actualizarCategoria(paramCategoria: any): any {

    if (this.consultaService.esNuevaSession) {
      paramCategoria.idUsuario = localStorage.getItem("paramId");
      paramCategoria.token = localStorage.getItem("paramToken");
      let promesa = new Promise((resolve, reject) => {

        console.log("Item to updtae")
        console.log(paramCategoria);

        let data = new URLSearchParams();
        let url = URL_SERVICIOS + '/categorias/actualizaCategoria';
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        this.http.post(url, paramCategoria, { headers })
          .map(resp => resp.json())
          .subscribe(data => {
            console.log(data);
            if (data.error) {
              resolve(false);
            } else {
              resolve(true);
            }

          })
      });
      return promesa;
    }
  }



  /**
   * Obtiene una lista de blogs
   */
  obtieneCategorias(idMarca: any) {

    let promesa = new Promise((resolve, reject) => {
      let url = URL_SERVICIOS + '/categorias/obtieneListaCategorias/' + idMarca;
      this.http.get(url)
        .map(resp => resp.json())
        .subscribe(data => {
          this.categorias = data.resultado;
          console.info("::: obtieneCategorias :::");
          console.info(this.categorias);
          resolve(true);
        });
    });
    return promesa;

  }


  /**
   * Obtiene una lista de imagenes del Producto
   */
  obtieneImagenes(idMc: any) {
    console.log('idMc', idMc);
    let promesa = new Promise((resolve, reject) => {
      let url = URL_SERVICIOS + '/categorias/obtieneListaImgMc/' + idMc;
      this.http.get(url)
        .map(resp => resp.json())
        .subscribe(data => {
          this.imagenes = data.resultado;
          console.info("::: obtieneImagenes :::");
          console.info(this.imagenes);
          resolve(true);
        });
    });
    return promesa;

  }


  /**
  Eliminar ImgSeccategoria
  */
    eliminarImgSeccategoria(paramImgSeccategoria: any) {
      console.log("::: Blog eliminaBlog service ");
      if (this.esNuevaSession) {
        paramImgSeccategoria.idUsuario = localStorage.getItem("paramId");
        paramImgSeccategoria.token = localStorage.getItem("paramToken");

        //console.log(paramBlog);
        let promesa = new Promise((resolve, reject) => {
          let data = new URLSearchParams();
          let url = URL_SERVICIOS + '/categorias/eliminarImgSecCat';
          let headers = new Headers({
            'Content-Type': 'application/json'
          })
          this.http.post(url, paramImgSeccategoria, { headers })
            .map(resp => resp.json())
            .subscribe(data => {
              //console.log(data);
              resolve(true);
            })
        });
        return promesa;
      }
    }


    esNuevaSession(): any {
      var nueva = false;
      if (localStorage.getItem("paramId") == null || localStorage.getItem("paramId") == '') {
        nueva = true;
        this.goLogin();
      }
      console.log("Es nueva sesion " + nueva);
      return nueva;
    }


    goLogin(): any {
      $("#btn_open_modal_perfiles").click();
      this.router.navigate(['/home']);
    }






}



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/services/categorias.service.ts